/**
 * 武将8名の一覧。
 *
 * 選択画面と検証がここを見る。東西の2ファイルに分けて並列に書いたため、
 * 「片方にしか足していない」が起きうる。バリデータが8名であることを
 * 検査するので、増減はビルドで落ちる。
 */

import { EAST_WARLORDS } from './east';
import { WEST_WARLORDS } from './west';
import type { Warlord } from '../types';

export const WARLORDS: readonly Warlord[] = [...EAST_WARLORDS, ...WEST_WARLORDS];

export const warlordById = (id: string): Warlord | undefined =>
  WARLORDS.find((w) => w.id === id);
